'use client';

import { useState } from 'react';
import Image from 'next/image';
import { PortableText } from '@portabletext/react';
import { PortableTextBlock } from 'sanity';
import { cn } from '@/lib/utils';
import { customRichTextComponent } from '@/sanity/sanityPortableText';
import WaitlistForm from '@/components/pageComponents/global/WaitlistForm';
import FormSuccessStep from '@/components/pageComponents/global/FormSuccessStep';
import PopupWatchImage from '@/public/global/popup-watch.png';
import Countdown from '../pageComponents/global/Countdown';

interface PopupContentProps {
  content?: PortableTextBlock[];
  additionalContent?: PortableTextBlock[];
  theme?: string;
  enableCountdown?: boolean;
  countdownTime?: string;
}

export default function PopupContent({
  content,
  additionalContent,
  theme,
  enableCountdown,
  countdownTime,
}: PopupContentProps) {
  const [step, setStep] = useState<'form' | 'success'>('form');

  const handleFormSuccess = () => {
    setStep('success');
  };

  return (
    <div
      className={cn(
        'w-full bg-black flex flex-col justify-center items-start px-[2rem] lg:px-[8rem] overflow-clip py-[4rem] lg:py-[10rem] relative lg:min-h-[100rem]',
      )}
    >
      <div className="lg:max-w-[70rem] flex flex-col gap-[6rem] lg:py-0 py-[5rem]">
        {step === 'form' ? (
          <>
            {content && (
              <div className="flex flex-col gap-[3.62rem]">
                {enableCountdown && (
                  <div className="">
                    <Countdown enableDays enableStrings date={countdownTime} />
                  </div>
                )}
                <div
                  className={cn(
                    'prose-headings:text-offwhite',
                    'richtext prose-headings:text-[3.75rem] md:prose-headings:text-[6rem] uppercase prose-headings:leading-none prose-headings:font-[200] prose-p:text-white/70 prose-p:text-[2rem] md:prose-p:text-[2.25rem] md:prose-p:px-[2rem] text-center lg:text-left',
                  )}
                >
                  <PortableText
                    value={content}
                    components={customRichTextComponent({})}
                  />
                </div>
              </div>
            )}

            <WaitlistForm onSuccess={handleFormSuccess} />
          </>
        ) : (
          <FormSuccessStep className="lg:items-start items-center text-center lg:text-start lg:px-0 px-[2rem] " />
        )}
      </div>

      <div className="lg:w-[100rem] lg:block hidden w-full h-auto absolute lg:top-0 top-auto bottom-0 lg:bottom-auto right-0 lg:right-[3rem]">
        <Image
          src={PopupWatchImage}
          alt="Popup Watch"
          className="!w-full !h-full !object-contain"
        />
      </div>
    </div>
  );
}
